const regexConstants = {
  ALPHABET_ONLY: new RegExp(/^[a-zA-Z]+$/),
  ALPHABET_SPACES: new RegExp(/^[a-zA-Z\s]+$/),
  ONLY_DECIMALS: new RegExp(/^\d+$/),
  EMAIL: new RegExp(
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  ),
  INTITUTE_DOMAIN_REG: new RegExp('^[a-zA-Z0-9][a-zA-Z0-9-_]*$'),
  SPACE_NOT_ALLOWED: new RegExp(/^\S*$/),
}

export default regexConstants
